import { useMemo, useState } from "react";
import strings from "../strings";
import BlinkingDot from "./BlinkingDot";
import TypewriterText from "./TypewriterText";

const VisitorsCounter = ({ count }) => {
  const [showCopy, setShowCopy] = useState(false);
  const formattedValue = count?.toLocaleString("en") ?? "";

  const copy = useMemo(
    () => strings.listeningNow + " " + formattedValue,
    [formattedValue]
  );

  if (count === null || count === undefined || count < 3) return null;

  return (
    <span className="red" id="visitors-counter">
      <TypewriterText
        delay={1000}
        className="red"
        onFinished={() => setShowCopy(true)}
      >
        {copy}
      </TypewriterText>
      {showCopy && (
        <BlinkingDot
          style={{ display: "inline-block", width: "10px", marginLeft: "4px" }}
          blinking
          className="red"
        />
      )}
    </span>
  );
};

export default VisitorsCounter;
